import { queryKeys } from '../../../../../queries/queryKeys';
import { getRequestAddresses } from '../../../../../queries/useRequestAddresses';
import { getProcessedData } from './helpers/getProcessedData';
import { generateRoomTitle } from './helpers/generateRoomTitle';
import { shutdownCompanyHousesQuery } from '../../api/queries';

const { fetchCompanyHouses } = shutdownCompanyHousesQuery;

export const fetchHouses = async ({
  queryClient,
  entityId,
  cityId,
  node,
  init,
}) => {
  const rawData = await fetchCompanyHouses({
    queryClient,
    params: { companyId: entityId, cityId },
    options: { staleTime: Infinity },
  });

  const data = getProcessedData(rawData, init);

  return data
    ? data.map((item) => ({
        title: item.fullAddress,
        key: `${node.key}-${item.id}`,
        id: item.id,
        parentId: entityId,
        searchPlaceholder: 'Поиск по дому',
        isLeaf: init?.size ? !init.get(item.id)?.size : false,
      }))
    : data;
};

const allHouseTypeId = 1;
export const fetchRooms = async ({ queryClient, entityId, node, init }) => {
  const rawData = await queryClient.fetchQuery(
    queryKeys.requestAddresses(entityId),
    () => getRequestAddresses(entityId),
    {
      staleTime: Infinity,
    }
  );

  const data = getProcessedData(rawData, init);

  return data
    ? data.reduce((acc, item) => {
        if (item.typeId !== allHouseTypeId) {
          acc.push({
            title: generateRoomTitle(item),
            id: item.id,
            parentId: entityId,
            key: `${node.key}-${item.id}`,
            searchPlaceholder: 'Поиск по помещению',
            isLeaf: true,
          });
        }
        return acc;
      }, [])
    : data;
};
